import { CommandKind } from "../../engine/commands/CommandBuffer";
import type { GameContext } from "../../engine/core/GameContext";
import { EventKind } from "../../engine/events/EventQueue";

/**
 * 爆浆的表现反馈：粒子与震屏，并把死亡转成回收请求。
 *
 * 计分与连击随[决策 0016](../../../../../docs/决策/0013-核心循环改为压力爆浆.md) 下线，
 * 已从此处移除——它此前与粒子混在一个叫 `scoring` 的文件里，而粒子是表现、分数是玩法。
 *
 * 随机走 `context.random`。此前它自带一套 LCG：不是 `Math.random`，但同样不随开局种子
 * 复位，回放照样对不上——随机源分裂比用错随机源更难发现。
 */
export class BurstFeedback {
  update(context: GameContext): void {
    const { events, slimes, state, metrics, catalog, commands } = context;
    for (let eventId = 0; eventId < events.count; eventId += 1) {
      if (events.kind[eventId] !== EventKind.EntityDied) continue;
      const target = events.target[eventId];
      if (target < 0 || slimes.active[target] === 0) continue;
      const definition = catalog.slimes[slimes.definition[target]];
      // value < 0：越线结算，在红线上原地爆开消失。不震屏、不计连锁，粒子少一些。
      const leak = events.value[eventId] < 0;
      if (!leak) {
        state.shake = Math.max(state.shake, 4);
        metrics.chainPops += 1;
      }
      this.spawnBurst(
        context,
        slimes.x[target],
        slimes.y[target],
        definition.visualColor,
        leak ? 6 : 12,
      );
      commands.lifecycle.push(CommandKind.DespawnSlime, -1, target);
    }
  }

  private spawnBurst(
    context: GameContext,
    x: number,
    y: number,
    color: number,
    count: number,
  ): void {
    const random = context.random;
    for (let index = 0; index < count; index += 1) {
      const angle = random.next() * Math.PI * 2;
      const speed = 80 + random.next() * 250;
      // 粒子池满时 spawn 返回 -1。丢弃是正常路径：本帧后续必然也满，直接停止。
      if (
        context.particles.spawn(
          x,
          y,
          Math.cos(angle) * speed,
          Math.sin(angle) * speed - 70,
          0.45 + random.next() * 0.35,
          2 + random.next() * 5,
          color,
        ) < 0
      )
        return;
    }
  }
}
